import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';
import api from '../../lib/api';

const KICKOFF_DATE = new Date('2026-10-08T18:00:00-04:00');

const getTimeLeft = () => {
  const diff = KICKOFF_DATE - new Date();
  if (diff <= 0) return null;
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};

const pad = (n) => String(n).padStart(2, '0');

export const KickoffBanner = () => {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());
  const [spots, setSpots] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => setTimeLeft(getTimeLeft()), 1000);
    api.get('/founding/spots').then((res) => setSpots(res.data)).catch(() => {});
    return () => clearInterval(timer);
  }, []);

  return (
    <Link to="/founding-members" className="block" data-testid="kickoff-banner">
      <div className="bg-[#5d6b3c] hover:bg-[#4b5731] transition-colors text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-center">
          <span className="flex items-center text-[20px] font-medium">
            <Sparkles className="w-5 h-5 mr-2 text-[#bd8cae]" />
            Next Meeting · Oct 8{' '}
            {timeLeft ? (
              <span className="font-mono tabular-nums ml-2" data-testid="banner-countdown">
                {timeLeft.days}d : {pad(timeLeft.hours)}h : {pad(timeLeft.minutes)}m : {pad(timeLeft.seconds)}s
              </span>
            ) : (
              <span className="ml-2">is here!</span>
            )}
          </span>
          {spots && spots.remaining > 0 && (
            <span className="text-[20px] text-[#f1e3eb]" data-testid="banner-spots">
              {spots.remaining} of {spots.goal} founding spots open
            </span>
          )}
          <span className="flex items-center text-[20px] font-semibold text-[#bd8cae]">
            Become a Founding Member
            <ArrowRight className="w-5 h-5 ml-1.5" />
          </span>
        </div>
      </div>
    </Link>
  );
};
